import { PropsWithChildren, createContext } from 'react';

const FeatureFlagsContext = createContext({
    showProfile: false,
    organizers: false,
    enableRoles: false,
});

const FeatureFlagsProvider = ({ children }: PropsWithChildren) => (
    <FeatureFlagsContext.Provider value={{ showProfile: false, organizers: false, enableRoles: false }}>
        {children}
    </FeatureFlagsContext.Provider>
);

export { FeatureFlagsContext, FeatureFlagsProvider };
